import { useCallback, useState } from 'react';
import useResizeObserver from './useResizeObserver';
import { fillDiv } from '@/utils';
import { useInvokeCallbackOnceWhen } from './useInvokeCallbackOnceWhen';

function useScalableTransform(
  isScalable: boolean,
  elInputContainer: React.MutableRefObject<HTMLDivElement | null>,
) {
  const [scale, setScaleValue] = useState(1);

  useResizeObserver(
    elInputContainer,
    useCallback(
      ({ contentRect }: ResizeObserverEntry) => {
        if (!isScalable) {
          return;
        }

        const scale = fillDiv(contentRect.width, contentRect.height);

        setScaleValue(scale);

        return;
      },
      [isScalable],
    ),
  );

  useInvokeCallbackOnceWhen(
    () => {
      if (elInputContainer.current?.style) {
        elInputContainer.current.style.transform = `scale( ${scale > 1 ? 1 : scale} )`;
        elInputContainer.current.style.transformOrigin = 'top left';
        elInputContainer.current.style.paddingBottom = '180px';
      }
    },
    isScalable && scale !== 1,
  );
}

export default useScalableTransform;
